'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default =

function (ProductModel, $location, $rootScope, $window) {
    "ngInject";
    return {
        restrict: 'A',
        scope: true,
        replace: true,
        link: function link(scope, element, attrs) {
            var setMultiselectDropdownOpen = function setMultiselectDropdownOpen(dropdown, open) {
                dropdown.multiselectClosing = !open;
                var panel = dropdown.querySelector('.number-multiselect-options');
                if (dropdown.multiselectAnimation) dropdown.multiselectAnimation.cancel();
                if (open) dropdown.open = true;
                if (!panel || !panel.animate) {
                    dropdown.open = open;
                    return;
                }
                var frames = [{ opacity: 0, transform: 'translateY(-4px)' }, { opacity: 1, transform: 'translateY(0)' }];
                var animation = panel.animate(open ? frames : frames.slice().reverse(), {
                    duration: 160, easing: 'ease-out', fill: 'both'
                });
                dropdown.multiselectAnimation = animation;
                animation.onfinish = function () {
                    dropdown.open = open;
                    animation.cancel();
                    dropdown.multiselectAnimation = null;
                    dropdown.multiselectClosing = false;
                };
            };
            scope.toggleMultiselectDropdown = function (event) {
                event.preventDefault();
                var dropdown = event.currentTarget.closest('details');
                setMultiselectDropdownOpen(dropdown, dropdown.multiselectClosing || !dropdown.open);
            };
            var onMultiselectOutsideClick = function onMultiselectOutsideClick(event) {
                element[0].querySelectorAll('.number-multiselect-dropdown[open]').forEach(function (dropdown) {
                    if (!dropdown.contains(event.target) && !dropdown.multiselectClosing) {
                        setMultiselectDropdownOpen(dropdown, false);
                    }
                });
            };
            document.addEventListener('click', onMultiselectOutsideClick, true);
            scope.$on('$destroy', function () {
                document.removeEventListener('click', onMultiselectOutsideClick, true);
            });

            var state = window.getComputedStyle(document.querySelector('.state-indicator'), ':before').getPropertyValue('content').replace(/"/g, ''),
                isProductPage = attrs.isProductPage == 'true';

            scope.skinSettings = (window.skinSettings || {}).product || {};
            scope.skinSettings.useFotorama = state != 'desktop';

            scope.section = {
                id: parseInt(attrs.sectionProduct, 10),
                configurationId: parseInt(attrs.configId, 10),
                imageTypes: angular.fromJson(attrs.imageTypes),
                template: attrs.template,
                url: attrs.url,
                link: attrs.link
            };
            var SESSION_LAST_SEARCH_KEY = 'lastSearch' + scope.section.id;

            scope.fotoRamaOptions = {
                width: '100%',
                height: 250,
                loop: true,
                keyboard: true,
                nav: 'thumbs',
                allowfullscreen: true
            };
            scope.fotoRamaImages = [];
            scope.$watch('localCurrent.fotoImages', function (images) {
                scope.fotoRamaImages = images;
            });

            scope.current = {
                showFilterPopup: false,
                infiniteScrollDisabled: true,
                isCollapsed: state != 'desktop'
            };

            scope.checkboxesState = $window.skinSettings && $window.skinSettings.products && $window.skinSettings.products.filter && $window.skinSettings.products.filter == 'on';
            scope.section.imageTypes = angular.extend(scope.section.imageTypes, $window.skinSettings.products && $window.skinSettings.products.imageTypes || {});

            scope.defaultFilter = {};
            scope.productFilter = {};
            scope.visualFilters = {};
            scope.enabledFilter = {}; // for checkboxes
            scope.products = [];
            scope.filterData = {};
            scope.searchData = {};
            // scope.activeVisualFilter = null;
            scope.hasActiveFilters = false;
            scope.activeHtml = null;
            scope.hideHTMLBelowCard = false;
            scope.isProductPage = isProductPage;
            scope.relatedProducts = [];

            if (isProductPage && window.utm_product_id && scope.section.configurationId) {
                ProductModel.getRelations({
                    id: window.utm_product_id,
                    configuration_id: scope.section.configurationId
                }, function (result) {
                    scope.relatedProducts = result.data || [];
                    console.log({ relatedProducts: scope.relatedProducts });
                }, function (error) {
                    console.error('Failed to fetch related products:', error);
                });
            }

            var hash = $location.hash();
            if (hash) {
                var scrollTo = ($('a[name="' + hash + '"]').offset() || {}).top || 0;
                scrollTo -= $('.navbar-fixed-top').height() || 0;
                $('html, body').animate({
                    scrollTop: parseInt(scrollTo)
                }, 500);
            }

            scope.$watch('localCurrent.tabs', function (tabs) {
                setTimeout(function () {
                    var scrollEl = /*state == 'desktop' ? '.product-section' : */'.product-attributes';
                    if ($(scrollEl).size() == 0) {
                        return;
                    }
                    var top = $(scrollEl).offset().top - $('.navbar.top').height() - $('.product-filter-outer').height();

                    $('html, body').animate({
                        scrollTop: top
                    }, 500);
                }, 200);
            }, true);

            scope.filterWith = function (name, value) {
                if (value === null) {
                    delete scope.productFilter[name];
                } else {
                    scope.productFilter[name] = value;
                }
                scope.filterProducts();
            };

            scope.filterProducts = function () {
                var productFilter = angular.copy(scope.productFilter);

                for (var key in scope.enabledFilter) {
                    if (scope.enabledFilter.hasOwnProperty(key) && !scope.enabledFilter[key]) {
                        delete productFilter[key];
                    }
                }
                var qs = (0, _helpers.filterToParams)(productFilter, scope.filterData.attributes, scope.enabledFilter);
                sessionStorage.setItem(SESSION_LAST_SEARCH_KEY, angular.toJson(qs));

                if (isProductPage) {
                    var q = (0, _helpers.filterToQs)(productFilter, scope.filterData.attributes, scope.enabledFilter);
                    q = (scope.section.url.indexOf('?') === -1 ? '?' : '&') + q;
                    location.href = scope.section.url + q;
                    return;
                }
                // if (qs) {
                //   qs = (scope.section.settings.url.indexOf('?') == -1 ? '?' : '&') + qs;
                // }

                var $target = $('.product-section-anchor', element);

                if ($target.length) {
                    var scrollTo = $target.offset().top - ($('.navbar-fixed-top').height() || 0);

                    $('html, body').animate({
                        scrollTop: scrollTo
                    }, 500);
                }

                scope.current.isCollapsed = true;
                $location.search(qs);

                scope.hasActiveFilters = true;
                scope.productFilter = (0, _helpers.qsToFilter)(qs, scope.filterData.attributes, {});
                scope.products = [];
                getProducts();
            };

            scope.getSelectedFilters = function () {
                return (scope.filterData.attributes || []).filter(function (filter) {
                    if (filter.hidden) return false;
                    var value = scope.productFilter[filter.name];
                    if (value === null || angular.isUndefined(value) || value === '') return false;
                    if ((filter.type === 'number' || filter.type === 'number-slider') && !scope.enabledFilter[filter.name]) return false;
                    if (angular.isArray(value)) {
                        return value.some(function (item) {
                            return item !== null && !angular.isUndefined(item) && item !== '';
                        });
                    }
                    return true;
                });
            };

            scope.getActiveFilterValue = function (filter) {
                var value = scope.productFilter[filter.name];
                if ((filter.type === 'number' || filter.type === 'number-slider') && !scope.enabledFilter[filter.name]) return '';
                if (value === null || angular.isUndefined(value)) return '';
                if (filter.type === 'boolean') {
                    return value === true || value === 'true' ? '?' : '?';
                }
                if (angular.isArray(value)) {
                    if (['number', 'number-slider', 'number-input'].indexOf(filter.type) !== -1) {
                        var min = value[0],
                            max = value[1];
                        var hasMin = min !== null && !angular.isUndefined(min) && min !== '';
                        var hasMax = max !== null && !angular.isUndefined(max) && max !== '';
                        if (hasMin && hasMax) return min + ' - ' + max;
                        if (hasMin) return '? ' + min;
                        if (hasMax) return '? ' + max;
                        return '';
                    }
                    return value.join(', ');
                }
                return String(value);
            };

            scope.toggleNumberMultiselect = function (name, value) {
                var selected = (scope.productFilter[name] || []).slice();
                value = String(value);
                var index = selected.indexOf(value);
                if (index === -1) {
                    selected.push(value);
                } else {
                    selected.splice(index, 1);
                }
                scope.productFilter[name] = selected;
            };

            scope.resetFilter = function () {
                scope.enabledFilter = {};
                scope.productFilter = {};
                scope.visualFilters = {};
                scope.section.activeFilters = {};
                angular.copy(scope.defaultFilter, scope.productFilter);
                //scope.filterProducts();
                $location.search({});
                sessionStorage.removeItem(SESSION_LAST_SEARCH_KEY);
                getProducts();
            };
            var getVisualFilterValue = function getVisualFilterValue(visualAttribute) {
                var value = angular.copy(visualAttribute.value);
                var name = visualAttribute.name && visualAttribute.name.trim();
                var attribute = (scope.filterData.attributes || []).find(function (item) {
                    return item.name === name;
                });
                var type = attribute && attribute.type || visualAttribute.type || '';

                if (angular.isArray(value)) {
                    return [parseInt(value[0]), parseInt(value[1])];
                }

                if (typeof value === 'number' || String(type).indexOf('number') === 0) {
                    value = parseInt(value);
                    return [value, value];
                }

                return value;
            };
            scope.formatVisualFilterValue = function (visualAttribute) {
                var value = visualAttribute && visualAttribute.value;

                if (angular.isArray(value)) {
                    return value.join(' - ');
                }

                return value;
            };
            scope.applyVisualFilter = function (visualAttribute) {
                // scope.activeVisualFilter = visualAttribute
                scope.enabledFilter = {};
                scope.section.activeFilters = {};
                scope.activeHtml = visualAttribute.html2;
                angular.copy(scope.defaultFilter, scope.productFilter);
                scope.visualFilters = {};
                var name = visualAttribute.name.trim();
                var value = getVisualFilterValue(visualAttribute);
                scope.enabledFilter[name] = true;
                scope.visualFilters[name] = value;
                scope.productFilter[name] = value;
                scope.filterProducts();
                scope.updateActiveFiltersState();
            };
            scope.canReset = function () {
                return Object.keys($location.search()).length > 0;
            };

            var onFilterChange = function onFilterChange() {
                if (scope.loadingCount || !scope.filterData) {
                    return;
                }
                //console.info('onFilterChange', scope.productFilter, scope.filterData.attributes);
                var args = scope.getQueryArguments();

                for (var key in scope.enabledFilter) {
                    if (scope.enabledFilter.hasOwnProperty(key) && scope.enabledFilter[key]) {
                        args['f' + key] = scope.productFilter[key];
                        if (angular.isArray(args['f' + key])) {
                            var attribute = scope.filterData.attributes.find(function (item) {
                                return item.name === key;
                            });
                            args['f' + key] = args['f' + key].join(attribute && (attribute.type === 'number-multiselect' || attribute.type === 'char-multiselect' || attribute.type === 'list-multiselect') ? ',' : '-');
                        }
                    }
                }
                //console.info('onFilterChange2', args);
                scope.loadingCount = true;

                args.section_id = scope.section.id;
                args.configuration_id = scope.section.configurationId;
                args.only_count = true;
                delete args.offset;
                getFilter();
                ProductModel.getProducts(args, function (res, headers) {
                    scope.filterCount = headers()['x-total-count'];
                    scope.loadingCount = false;
                });
            };
            scope.$watch('enabledFilter', onFilterChange, true);
            scope.$watch('productFilter', onFilterChange, true);
            scope.$watch('visualFilters', onFilterChange, true);

            var getSearch = function () {
                return ProductModel.getSearchs({
                    configurationId: scope.section.configurationId
                }, function (result) {
                    if (result.searchData && Object.prototype.hasOwnProperty.call(result.searchData, 'disabled') && !result.searchData.disabled) {
                        return scope.searchData = angular.extend(scope.searchData, result.searchData);
                    }

                    return scope.searchData.disabled = true;
                }).$promise;
            }();

            scope.loadMore = function () {
                if (!scope.productsData) {
                    return;
                }
                getProducts();
            };

            scope.goto = function (url) {
                if (!url) return;
                location.href = url;
            };

            var firstFilterCall = true;
            var getFilter = function getFilter() {
                var args = scope.filterData ? scope.getQueryArguments() : {};
                args.configurationId = scope.section.configurationId;

                for (var key in scope.enabledFilter) {
                    if (scope.enabledFilter.hasOwnProperty(key) && scope.enabledFilter[key]) {
                        args['f' + key] = scope.productFilter[key];
                        if (angular.isArray(args['f' + key])) {
                            var attribute = scope.filterData.attributes.find(function (item) {
                                return item.name === key;
                            });
                            args['f' + key] = args['f' + key].join(attribute && (attribute.type === 'number-multiselect' || attribute.type === 'char-multiselect' || attribute.type === 'list-multiselect') ? ',' : '-');
                        }
                    }
                }
                return ProductModel.getFilters(args, function (res) {
                    if (!firstFilterCall) {
                        $.each(res.attributes, function (n, attribute) {
                            var attr = scope.filterData.attributes.find(function (item) {
                                return item.id == attribute.id;
                            });
                            if (!attr || args['f' + attr.name]) {
                                return;
                            }
                            if (attribute.range) {
                                scope.productFilter[attr.name] = [parseInt(attribute.range.min), parseInt(attribute.range.max)];
                            }
                            attr.values = attribute.values;
                            attr.showItemCounts = attribute.showItemCounts;
                            attr.valueCounts = attribute.valueCounts;
                        });
                        return;
                    }
                    res.attributes = $.each(res.attributes, function (n, attribute) {
                        if (attribute.range) {
                            attribute.range.min = parseInt(attribute.range.min);
                            attribute.range.max = parseInt(attribute.range.max);
                        }
                        return attribute;
                    });
                    scope.filterData = res;
                    firstFilterCall = false;
                    scope.current.infiniteScrollDisabled = scope.filterData.loadListChunks == 'manual';

                    scope.defaultFilter = (0, _helpers.qsToFilter)({}, scope.filterData.attributes, {});
                    scope.productFilter = (0, _helpers.qsToFilter)($location.search(), scope.filterData.attributes, {});

                    if (scope.checkboxesState) {
                        $.each(scope.filterData.attributes, function (n, attribute) {
                            if (attribute.type === 'number-slider' && !attribute.hidden) {
                                scope.enabledFilter[attribute.name] = true;
                            }
                        });
                    }
                }).$promise;
            };

            scope.getQueryArguments = function () {
                var args = {
                    section: scope.section.id,
                    offset: scope.products.length
                },
                    filter = (0, _helpers.filterToParams)(scope.productFilter, scope.filterData.attributes, {}, true);

                return angular.extend(args, filter);
            };

            var getProducts = function getProducts() {
                // get product only when no active loading and its first query on product page (for counter of products)
                if (scope.loading) {
                    return;
                }

                var args = scope.getQueryArguments();

                var enabled = (0, _helpers.qsToFilter)($location.search(), scope.filterData.attributes, {}, true),
                    activeFilter = {};

                $.each(enabled, function (filterName, value) {
                    if (!value || Array.isArray(value) && (!value.length || value[0] === null && value[1] === null)) {
                        return;
                    }
                    activeFilter[filterName] = scope.filterData.attributes.find(function (item) {
                        return item.name === filterName;
                    });
                    if (!activeFilter[filterName]) {
                        delete activeFilter[filterName];
                    } else {
                        scope.enabledFilter[filterName] = true;
                    }
                });
                for (var key in scope.enabledFilter) {
                    if (scope.enabledFilter.hasOwnProperty(key) && scope.enabledFilter[key]) {
                        args['f' + key] = scope.productFilter[key];
                        if (angular.isArray(args['f' + key])) {
                            var attribute = scope.filterData.attributes.find(function (item) {
                                return item.name === key;
                            });
                            args['f' + key] = args['f' + key].join(attribute && (attribute.type === 'number-multiselect' || attribute.type === 'char-multiselect' || attribute.type === 'list-multiselect') ? ',' : '-');
                        }
                    }
                }
                scope.section.activeFilters = activeFilter;
                scope.section.hasActiveFilters = Object.keys(activeFilter).length;

                scope.isCanReset = scope.canReset();
                scope.loading = true;
                scope.current.showFilterPopup = false;

                args.section_id = scope.section.id;
                args.configuration_id = scope.section.configurationId;

                if (!scope.searchData.disabled && scope.searchData.query && angular.isArray(scope.searchData.attributes)) {
                    scope.searchData.attributes.forEach(function (attributeName) {
                        return args['search' + attributeName] = scope.searchData.query;
                    });
                }

                ProductModel.getProducts(args, function (res) {
                    scope.productsData = res.data;
                    scope.loaded = !res.data.nextCount;

                    scope.products = scope.products.concat($.map(res.data.products, function (product) {
                        // replace url if set link in simple product section
                        if (scope.section.template === 'simple-product') {
                            if (scope.section.link && scope.section.link !== '') {
                                var str = product.url;
                                product.url = scope.section.link + str.substring(str.lastIndexOf('/'));
                                product.url = product.url.replace(location.origin, '');
                            }
                        }
                        return product;
                    }));
                    scope.loading = false;
                });
            };

            getFilter().then(function () {
                scope.loadingCount = true;
                if (isProductPage) {
                    var lastSearch = sessionStorage.getItem(SESSION_LAST_SEARCH_KEY);
                    if (lastSearch) {
                        scope.productFilter = (0, _helpers.qsToFilter)(angular.fromJson(lastSearch), scope.filterData.attributes, {}, true);
                        scope.section.activeFilters = {};
                        $.each(scope.productFilter, function (filterName, value) {
                            if (!value) {
                                return;
                            }
                            var name = filterName.substring(0);
                            scope.section.activeFilters[name] = scope.filterData.attributes.find(function (item) {
                                return item.name == name;
                            });
                            if (!scope.section.activeFilters[name]) {
                                delete scope.section.activeFilters[name];
                            } else {
                                scope.enabledFilter[name] = true;
                            }
                            if (scope.section.activeFilters[name] === '-') {
                                delete scope.section.activeFilters[name];
                            }
                        });
                        console.info('active', scope.section.activeFilters);
                        scope.section.hasActiveFilters = Object.keys(scope.section.activeFilters).length;
                        scope.isCanReset = scope.section.hasActiveFilters;

                        scope.updateActiveFiltersState();

                        var q = (0, _helpers.filterToQs)(scope.productFilter, scope.filterData.attributes, {}, true);
                        q = (scope.section.url.indexOf('?') === -1 ? '?' : '&') + q;
                        $('#productPageBackButton').attr('href', scope.section.url + q);
                        scope.loadingCount = false;
                    }
                } else {
                    scope.productFilter = (0, _helpers.qsToFilter)($location.search(), scope.filterData.attributes, {}, true);
                    scope.restoreActiveVisualFilter();
                    scope.updateActiveFiltersState();
                    scope.products = [];

                    var activeFilter = {};

                    $.each(scope.productFilter, function (filterName, value) {
                        if (!value) {
                            return;
                        }
                        activeFilter[filterName] = scope.filterData.attributes.find(function (item) {
                            return item.name === filterName;
                        });
                        if (!activeFilter[filterName]) {
                            delete activeFilter[filterName];
                        } else {
                            scope.enabledFilter[filterName] = true;
                        }
                    });

                    firstFilterCall = true;
                    scope.loadingCount = false;
                    getFilter().then(getProducts);
                }
            });

            scope.removeFilter = function (filter) {
                delete scope.enabledFilter[filter.name];
                if (scope.visualFilters) {
                    delete scope.visualFilters[filter.name];
                    if (scope.filterData && scope.filterData.visualFilters && scope.filterData.visualFilters.hideHTMLBelowCard) {
                        scope.activeHtml = null;
                    }
                }
                if (filter.type === 'number-slider') {
                    scope.filterWith(filter.name, [parseInt(filter.range.min), parseInt(filter.range.max)]);
                } else if (filter.type === 'number-input') {
                    scope.filterWith(filter.name, null);
                } else {
                    scope.filterWith(filter.name, null);
                }
                scope.updateActiveFiltersState();
            };
            scope.isFilterActive = function (visualAttribute) {
                // console.log({filter: scope.productFilter})
                var name = visualAttribute.name.trim();
                var value = getVisualFilterValue(visualAttribute);
                var result = scope.productFilter && angular.equals(scope.productFilter[name], value);
                if (result && visualAttribute.html2) {
                    scope.activeHtml = visualAttribute.html2;
                }
                return result;
            };
            scope.isActiveFilters = function () {
                var hasProductFilters = scope.productFilter && Object.keys(scope.productFilter).length > 0;

                var isDifferentFromDefault = JSON.stringify(scope.productFilter) !== JSON.stringify(scope.defaultFilter);
                return hasProductFilters && isDifferentFromDefault || scope.visualFilters && Object.keys(scope.visualFilters).length > 0;
            };
            scope.updateActiveFiltersState = function () {
                var hasProductFilters = scope.productFilter && Object.keys(scope.productFilter).length > 0;

                var isDifferentFromDefault = JSON.stringify(scope.productFilter) !== JSON.stringify(scope.defaultFilter);

                scope.hasActiveFilters = hasProductFilters && isDifferentFromDefault || scope.visualFilters && Object.keys(scope.visualFilters).length > 0;
            };
            scope.restoreActiveVisualFilter = function () {
                // scope.activeVisualFilter = null;
                scope.visualFilters = {};

                var visualAttributes = scope.filterData && scope.filterData.visualFilters && scope.filterData.visualFilters.attributes;

                if (!visualAttributes || !visualAttributes.length) {
                    return;
                }

                var activeVisualAttribute = visualAttributes.find(function (item) {
                    var name = item.name && item.name.trim();
                    var value = getVisualFilterValue(item);

                    return name && scope.productFilter && angular.equals(scope.productFilter[name], value);
                });

                if (activeVisualAttribute) {
                    var name = activeVisualAttribute.name.trim();

                    // scope.activeVisualFilter = activeVisualAttribute;
                    scope.visualFilters[name] = getVisualFilterValue(activeVisualAttribute);
                    scope.enabledFilter[name] = true;
                }
            };
        }
    };
};

var _helpers = require('../helpers');


// WEBPACK FOOTER //
// ./app/modules/sections/product/directives/sectionProduct.js